export const frValidationMessages: any = { // French error messages
  required: 'Est obligatoire.',
  minLength: 'Doit avoir minimum {{minimumLength}} caractÃ¨res (actuellement: {{currentLength}})',
  maxLength: 'Doit avoir maximum {{maximumLength}} caractÃ¨res (actuellement: {{currentLength}})',
  pattern: 'Doit respecter: {{requiredPattern}}',
  format: function (error) {
    switch (error.requiredFormat) {
      case 'date':
        return 'Doit Ãªtre une date, tel que "2000-12-31"';
      case 'time':
        return 'Doit Ãªtre une heure, tel que "16:20" ou "03:14:15.9265"';
      case 'date-time':
        return 'Doit Ãªtre une date et une heure, tel que "2000-03-14T01:59" ou "2000-03-14T01:59:26.535Z"';
      case 'email':
        return 'Doit Ãªtre une adresse e-mail, tel que "name@example.com"';
      case 'hostname':
        return 'Doit Ãªtre un nom de domaine, tel que "example.com"';
      case 'ipv4':
        return 'Doit Ãªtre une adresse IPv4, tel que "127.0.0.1"';
      case 'ipv6':
        return 'Doit Ãªtre une adresse IPv6, tel que "1234:5678:9ABC:DEF0:1234:5678:9ABC:DEF0"';
      // TODO: add examples for 'uri', 'uri-reference', and 'uri-template'
      // case 'uri': case 'uri-reference': case 'uri-template':
      case 'url':
        return 'Doit Ãªtre une URL, tel que "http://www.example.com/page.html"';
      case 'uuid':
        return 'Doit Ãªtre un UUID, tel que "12345678-9ABC-DEF0-1234-56789ABCDEF0"';
      case 'color':
        return 'Doit Ãªtre une couleur, tel que "#FFFFFF" or "rgb(255, 255, 255)"';
      case 'json-pointer':
        return 'Doit Ãªtre un JSON Pointer, tel que "/pointer/to/something"';
      case 'relative-json-pointer':
        return 'Doit Ãªtre un relative JSON Pointer, tel que "2/pointer/to/something"';
      case 'regex':
        return 'Doit Ãªtre une expression rÃ©guliÃ¨re, tel que "(1-)?\\d{3}-\\d{3}-\\d{4}"';
      default:
        return 'Doit Ãªtre avoir le format correct: ' + error.requiredFormat;
    }
  },
  minimum: 'Doit Ãªtre supÃ©rieur Ã  {{minimumValue}}',
  exclusiveMinimum: 'Doit avoir minimum {{exclusiveMinimumValue}} charactÃ¨res',
  maximum: 'Doit Ãªtre infÃ©rieur Ã  {{maximumValue}}',
  exclusiveMaximum: 'Doit avoir maximum {{exclusiveMaximumValue}} charactÃ¨res',
  multipleOf: function (error) {
    if ((1 / error.multipleOfValue) % 10 === 0) {
      const decimals = Math.log10(1 / error.multipleOfValue);
      return `Doit comporter ${decimals} ou moins de decimales.`;
    } else {
      return `Doit Ãªtre un multiple de ${error.multipleOfValue}.`;
    }
  },
  minProperties: 'Doit comporter au minimum {{minimumProperties}} Ã©lÃ©ments',
  maxProperties: 'Doit comporter au maximum {{maximumProperties}} Ã©lÃ©ments',
  minItems: 'Doit comporter au minimum {{minimumItems}} Ã©lÃ©ments',
  maxItems: 'Doit comporter au maximum {{minimumItems}} Ã©lÃ©ments',
  uniqueItems: 'Tous les Ã©lÃ©ments doivent Ãªtre uniques',
  // Note: No default error messages for 'type', 'const', 'enum', or 'dependencies'
};
